import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StudentCounsellingDetialsReportRoutingModule } from './student-counselling-detials-report-routing.module';
import { StudentCounsellingDetailsLandingComponent } from './student-counselling-details-landing/student-counselling-details-landing.component';
import { StudentCounsellingDetailsLinkComponent } from './student-counselling-details-link/student-counselling-details-link.component';
import { StudentCounsellingDetailsComponent } from './student-counselling-details/student-counselling-details.component';
import { StudentCounsellingDetailsDialogComponent } from './student-counselling-details-dialog/student-counselling-details-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AgGridModule } from 'ag-grid-angular';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { StudentCounsellingDetailsPageComponent } from './student-counselling-details-page/student-counselling-details-page.component';
import { StudentCounsellingDetailsExcelpageComponent } from './student-counselling-details-excelpage/student-counselling-details-excelpage.component';


@NgModule({
  declarations: [
    StudentCounsellingDetailsLandingComponent,
    StudentCounsellingDetailsLinkComponent,
    StudentCounsellingDetailsComponent,
    StudentCounsellingDetailsDialogComponent,
    StudentCounsellingDetailsPageComponent,
    StudentCounsellingDetailsExcelpageComponent
  ],
  imports: [
    CommonModule,
    StudentCounsellingDetialsReportRoutingModule,
    AcademicFormModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatCardModule,
    MatTableModule,
    MatDatepickerModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    AgGridModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
  ]
})
export class StudentCounsellingDetialsReportModule { }
